import { get } from '@/services/Axios';
import debounce from 'lodash.debounce';
import errorHandler from '@/mixins/errorHandler';

export default {
  mixins: [errorHandler],
  data() {
    return {
      provinces: [],
      cities: [],
      subdistricts: [],
      villages: [],
      loadProvinces: false,
      loadCities: false,
      loadSubdistricts: false,
      loadVillages: false,
      customValue: false,
      searchProvinces: '',
      searchCities: '',
      searchSubdistricts: '',
      searchVillages: '',
      formAddressName: null,
      disabledCities: true,
      disabledSubdistricts: true,
      disabledVillages: true,
      defaultArea: false,
      defaultProvince: {
        provinceId: '34',
        provinceName: 'Di Yogyakarta'
      }
    };
  },
  mounted() {
    if (!this.defaultArea) this.getProvinces();
    if (this[this.formAddressName] && this.defaultArea) {
      this.provinces = [this.defaultProvince];
      this[this.formAddressName].province = this.defaultProvince;
    }
  },
  computed: {
    provinceWatcher() {
      return this[this.formAddressName].province;
    },
    cityWatcher() {
      return this[this.formAddressName].city;
    },
    subdistrictWatcher() {
      return this[this.formAddressName].subdistrict;
    }
  },
  watch: {
    provinceWatcher(after, before) {
      if (!this.defaultArea) {
        if (before && this.formAddressName) {
          this[this.formAddressName].city = null;
          this[this.formAddressName].subdistrict = null;
          this[this.formAddressName].village = null;
          this.disabledCities = true;
          this.disabledSubdistricts = true;
          this.disabledVillages = true;
        }
        if (after && after.id == 'all') {
          this.disabledCities = true;
        } else if (after) {
          this.disabledCities = false;
        }
        this.getCities();
      }
    },
    cityWatcher(after, before) {
      if (before && this.formAddressName) {
        this[this.formAddressName].subdistrict = null;
        this[this.formAddressName].village = null;
        this.disabledSubdistricts = true;
        this.disabledVillages = true;
      }
      if (after && after.id == 'all') {
        this.disabledSubdistricts = true;
      } else if (after) {
        this.disabledSubdistricts = false;
      }
      this.getSubdistricts();
    },
    subdistrictWatcher(after, before) {
      if (before && this.formAddressName) {
        this[this.formAddressName].village = null;
        this.disabledVillages = true;
      }
      if (after && after.id == 'all') {
        this.disabledVillages = true;
      } else if (after) {
        this.disabledVillages = false;
      }
      this.getVillages();
    },
    searchProvinces(val) {
      if (
        val &&
        (!this[this.formAddressName].province ||
          val !== this[this.formAddressName].province.provinceName)
      ) {
        this.getProvinces(val);
      }
    },
    searchCities(val) {
      if (
        !this[this.formAddressName].city ||
        val !== this[this.formAddressName].city.cityName
      ) {
        this.getCities(val);
      }
    },
    searchSubdistricts(val) {
      if (
        !this[this.formAddressName].subdistrict ||
        val !== this[this.formAddressName].subdistrict.subdistrictName
      ) {
        this.getSubdistricts(val);
      }
    },
    searchVillages(val) {
      if (
        !this[this.formAddressName].district ||
        val !== this[this.formAddressName].district.districtName
      ) {
        this.getVillages(val);
      }
    }
  },
  methods: {
    getProvinces: debounce(async function(name) {
      this.loadProvinces = true;
      const params = {
        sort: 'province_name',
        dir: 'ASC',
        filter: [
          {
            type: 'string',
            field: 'province_name',
            value: name || '',
            comparison: '<>'
          }
        ]
      };
      try {
        const {
          data: { results }
        } = await get('/get-province', { params });

        if (this.customValue) {
          results.splice(0, 0, {
            id: 'all',
            name: 'Semua Provinsi'
          });
        }

        this.provinces = results;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadProvinces = false;
      }
    }, 500),
    getCities: debounce(async function(name) {
      if (
        this[this.formAddressName].province &&
        this[this.formAddressName].province.id != 'all'
      ) {
        this.loadCities = true;
        const params = {
          sort: 'city_name',
          dir: 'ASC',
          province_id: this[this.formAddressName].province.provinceId,
          filter: [
            {
              type: 'string',
              field: 'city_name',
              value: name || '',
              comparison: '<>'
            }
          ]
        };
        try {
          const {
            data: { results }
          } = await get('/get-city', { params });

          if (this.customValue) {
            results.splice(0, 0, {
              id: 'all',
              name: 'Semua Kota'
            });
          }

          this.cities = results;
        } catch (e) {
          throw this.handleError(e);
        } finally {
          this.loadCities = false;
        }
      }
    }, 500),
    getSubdistricts: debounce(async function(name) {
      if (
        this[this.formAddressName].city &&
        this[this.formAddressName].city.id != 'all'
      ) {
        this.loadSubdistricts = true;
        const params = {
          sort: 'subdistrict_name',
          dir: 'ASC',
          city_id: this[this.formAddressName].city.cityId,
          filter: [
            {
              type: 'string',
              field: 'subdistrict_name',
              value: name || '',
              comparison: '<>'
            }
          ]
        };
        try {
          const {
            data: { results }
          } = await get('/get-subdistrict', { params });

          if (this.customValue) {
            results.splice(0, 0, {
              id: 'all',
              name: 'Semua Kecamatan'
            });
          }

          this.subdistricts = results;
        } catch (e) {
          throw this.handleError(e);
        } finally {
          this.loadSubdistricts = false;
        }
      }
    }, 500),
    getVillages: debounce(async function(name) {
      if (
        this[this.formAddressName].subdistrict &&
        this[this.formAddressName].subdistrict.subdistrictId != 'all'
      ) {
        this.loadVillages = true;
        const params = {
          sort: 'district_name',
          dir: 'ASC',
          subdistrict_id: this[this.formAddressName].subdistrict.subdistrictId,
          filter: [
            {
              type: 'string',
              field: 'district_name',
              value: name || '',
              comparison: '<>'
            }
          ]
        };
        try {
          const {
            data: { results }
          } = await get('/get-district', { params });

          if (this.customValue) {
            results.splice(0, 0, {
              id: 'all',
              name: 'Semua Desa'
            });
          }

          this.villages = results;
        } catch (e) {
          throw this.handleError(e);
        } finally {
          this.loadVillages = false;
        }
      }
    }, 500)
  }
};
